<template>
    <div class="search-area">
        <div  style="padding:8px 0px; display: flex;align-items: center; ">

           <el-form class="demo-form-inline" style="width:100%;">
                <div style="width:100%;display:flex;align-items: center;">
                    <div style="width:70%;display:flex;align-items: center; justify-content: flex-start; ">
                        <div class="input-group-search" >
                          <el-input
                            id="loginAccount"
                            v-model="searchParam.loginAccount"
                            class="input-field"
                            clearable
                            style="width:260px;"
                            placeholder=" "
                          />
                          <label for="loginAccount" class="floating-label">账号或者姓名</label>
                        </div>
                        <div class="input-group-search">
                          <el-input type="text" id="phone" v-model="searchParam.phone" class="input-field" clearable style="width:260px;" placeholder=" " />
                          <label for="phone" class="floating-label">手机号</label>
                        </div>
                          <div class="input-group" style="width: 260px;" :class="{ 'has-value': searchParam.status !== '' }">
                            <el-select
                              v-model="searchParam.status"
                              id="loginAccount1"
                              class="select-field"
                              style="width:260px;"
                              clearable
                              placeholder=" "
                            >
                              <el-option
                                v-for="item in statusOpt"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                            <label for="loginAccount1" class="floating-label1">状态</label>
                          </div>

                    </div>
                    <div style="width:30%;text-align:right; font-size: 24px; cursor: pointer;">

                        <el-tooltip class="item" effect="dark"  content="新增" placement="bottom">
                            <i class="el-icon-plus" @click="addOpenDrawer" ></i>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark"  content="刷新" placement="bottom">
                            <i class="el-icon-refresh" @click="getPage" ></i>
                        </el-tooltip>

                    </div>

                </div>

            </el-form>

        </div>


       <el-table class="table-data" :data="tableData" :height="tableHeight"  style="width:100%; margin-bottom: 10px; ">

                  <el-table-column
                prop="loginAccount"
                label="登录账号"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="accountName"
                label="姓名"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="phone"
                label="手机号"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="accountType"
                label="账号类型"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="status"
                label="账号状态"
                style="width:150">
         </el-table-column>
         <!-- <el-table-column
                prop="roleId"
                label="外键 所属角色Id"
                style="width:150">
         </el-table-column> -->
         <el-table-column
                prop="lastUpdateTime"
                label="最后修改时间"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="createTime"
                label="创建时间"
                style="width:150">
         </el-table-column>

            <el-table-column
                    label="操作"
                    fixed="right"
                    width="200"
                    >
                <template slot-scope="scope">
                    <el-tooltip class="item table-btn-icon" effect="dark" content="查看详情" placement="bottom">
                        <i class="el-icon-edit table-icon" @click="getId(scope.row)"></i>
                    </el-tooltip>

                     <el-tooltip class="item table-btn-icon" effect="dark" content="删除" placement="bottom">
                        <i class="el-icon-delete table-icon" @click="deleteById(scope.row)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @next-click="nextClick"
                @prev-click="prevClick"
                :current-page="pageUtil.curPage"
                :page-sizes="[20, 30, 50, 100,200]"
                :page-size="pageUtil.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageUtil.total"
                style="height: 30px; line-height: 30px; margin:10px auto; text-align: center;">
        </el-pagination>

        <el-drawer
          title="编辑"
          :visible.sync="isOpenDrawer"
          :wrapperClosable="false"
          direction="rtl"
          :before-close="handleClose">
           <!-- 使用flex布局确保底部固定 -->
          <div class="drawer-container">
            <!-- 可滚动的内容区域 -->
            <div class="drawer-content">
              <!-- <span>我来啦!</span> -->
              <!-- 这里可以放置您的表单或其他内容 -->
              <!-- <div style="height: 1500px; background: #f5f5f5; margin-top: 20px;">
                模拟长内容区域
              </div> -->

              <el-form :model="account" ref="baseForm" :rules="rules">

              <div class="input-group" >
               <el-form-item prop="loginAccount" >
                    <el-input type="text" id="loginAccount" :disabled="optBtnStatus =='update'?true:false" v-model="account.loginAccount" class="input-field" placeholder=" " />
                     <label for="loginAccount" class="floating-label">* 管理员登录账号</label>
               </el-form-item>
             </div>

              <div class="input-group" >
               <el-form-item prop="password" >
                    <el-input type="password" id="password" v-model="account.password" class="input-field" placeholder=" " />
                     <label for="password" class="floating-label">* 密码</label>
               </el-form-item>
             </div>

             <div class="input-group" >
               <el-form-item prop="password1" >
                    <el-input type="password" id="password1" v-model="account.password1" class="input-field" placeholder=" " />
                     <label for="password1" class="floating-label">* 确认密码</label>
               </el-form-item>
             </div>

              <div class="input-group" >
               <el-form-item prop="accountName" >
                    <el-input type="text" id="accountName" v-model="account.accountName" class="input-field" placeholder=" " />
                     <label for="accountName" class="floating-label">* 姓名</label>
               </el-form-item>
             </div>

           
              <div class="input-group" >
               <el-form-item prop="phone" >
                    <el-input type="text" id="phone" v-model="account.phone" class="input-field" placeholder=" " />
                     <label for="phone" class="floating-label">* 手机号</label>
               </el-form-item>
             </div>

             <div class="input-group m-top20" :class="{ 'has-value': account.accountType !== '' }">
               <el-form-item prop="accountType" >
                    <el-select
                      v-model="account.accountType" 
                      id="accountType"
                      class="select-field"
                      clearable
                      placeholder=" "
                    >
                      <el-option
                        v-for="item in accountTypeOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                     </el-select>
                      <label for="accountType" class="floating-label1" style="border:0px;">* 账号类型</label>
                     </el-form-item>
              </div>

              <div class="input-group m-top20" v-if="optBtnStatus =='update'" :class="{ 'has-value': account.status !== '' }">
                <el-form-item prop="status" >
                    <el-select
                      v-model="account.status" 
                      prop="status" 
                      id="status"
                      class="select-field"
                      clearable
                      placeholder=" "
                    >
                      <el-option
                        v-for="item in statusOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                     </el-select>
                     <label for="status" class="floating-label1" style="border:0px;">* 账号状态</label>
                  </el-form-item>
              </div>

              <!-- <div class="input-group" >
               <el-form-item prop="roleId" >
                    <el-input type="text" id="roleId" v-model="account.roleId" class="input-field" placeholder=" " />
                     <label for="roleId" class="floating-label">所属角色</label>
               </el-form-item>
             </div> -->

              <div class="input-group" v-if="optBtnStatus =='update'" >
               <el-form-item prop="lastUpdateTime" >
                    <el-input type="text" id="lastUpdateTime" v-model="account.lastUpdateTime" disabled="false" class="input-field" placeholder=" " />
                     <label for="lastUpdateTime" class="floating-label">最后修改时间</label>
               </el-form-item>
             </div>

              <div class="input-group" v-if="optBtnStatus =='update'" >
               <el-form-item prop="createTime" >
                    <el-input type="text" id="createTime" v-model="account.createTime" disabled="false" class="input-field" placeholder=" " />
                     <label for="createTime" class="floating-label">创建时间</label>
               </el-form-item>
             </div>

              </el-form>


            </div>

            <!-- 固定的底部按钮区域 -->
            <div class="drawer-footer">
              <el-button type="primary" @click="save">保存</el-button>
            </div>
          </div>

        </el-drawer>
     </div>


  </template>

<script>



  var _this;
export default {
  name: 'Role',
  data () {

      const checkPassword = (rule, value, callback) => {

        if (value !== _this.account.password) {
          
          return callback(new Error('两次密码输入不一致！'));
        }
         callback();
      };

   
    return {
      tableHeight: 200,
      pageUtil:{total:0,pageSize:20,curPage:1},
      tableData:[],
      searchParam:{
          loginAccount: '',
          phone: '',
          status: '',
      },statusOpt:[
         { value: 0, label: '正常'},
         { value: 1, label: '禁用'}

      ],accountTypeOpt:[
         { value: 0, label: '系统管理员'},
         { value: 1, label: '普通管理员'}
      ],
      isOpenDrawer:false,
      optBtnStatus:'',
      optBtnInfo:{},
      account:{"loginAccount":"","password":"","accountName":"","phone":"","roleId":"","accountType":"","status":""},
      dialogVisible: false,
      rules: {
       loginAccount: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        { min: 3, max: 64, message: '长度在 3 到 64 个字符', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 3, max: 32, message: '长度在 3 到 32 个字符', trigger: 'blur' }
      ],password1: [
        { required: true, message: '请输入确认密码', trigger: 'blur' },
        { min: 3, max: 32, message: '长度在 3 到 32 个字符', trigger: 'blur' },
        { validator: checkPassword, trigger: 'blur' }
        
      ],
      accountName: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
        { min: 1, max: 128, message: '长度在 3 到 128 个字符', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { min: 11, max: 11, message: '长度在11个字符', trigger: 'blur' }
      ],
      accountType: [
         { required: true, message: '请输入账号类型', trigger: 'blur' },
      ]
      }

    }
  }, mounted(){

    //_this.initContentHeight(_this);
      _this.$com.initContentHeight(_this);
      _this.getPage();

  },created: function () {
      _this = this;

  },methods:{

     getPage(){

       try {

            var param = _this.searchParam;

            param['pageSize'] = _this.pageUtil.pageSize;
            param['curPager'] = _this.pageUtil.curPage;

            _this.$http.get('/back_bin/account/get_page', param,(response)=>{

            _this.pageUtil.total = response.data.countSum;
            _this.pageUtil.curPage = response.data.curPager;
            let list = response.data.list;
            if(list!=null && list.length > 0){

              for(let i=0;i<list.length;i++){

                let bean = list[i];

                if(bean.accountType == 0){
                  bean.accountType = '系统管理员';
                }else if(bean.accountType == 1){
                  bean.accountType = '普通管理员';
                }

                 if(bean.status == 0){
                  bean.status = '正常';
                }else if(bean.status == 1){
                  bean.status = '已禁用';
                }

                bean.createTime = _this.$com.dateConvertTime(bean.createTime);
                bean.lastUpdateTime = _this.$com.dateConvertTime(bean.lastUpdateTime);

              }

            }

            _this.tableData = list;
             console.info('请求结果1:', response )
            if(response .status == 'success'){


            }

            });

          } catch (error) {
            console.error('请求失败:', error)
          }


        },nextClick:function(){

            _this.pageUtil.curPage = _this.pageUtil.curPage+1;
            _this.getPage();

        },prevClick:function(){

            _this.pageUtil.curPage = _this.pageUtil.curPage-1;
            _this.getPage();

        },handleSizeChange:function(val) {

            _this.pageUtil.pageSize = val;

        },handleCurrentChange:function(val) {

            _this.pageUtil.curPage = val;
            _this.getPage();

        },addOpenDrawer:function(){

          _this.optBtnStatus = 'add';
           _this.resetForm();
           _this.isOpenDrawer = true;
           // 重置表单数据和验证状态
           _this.$refs.baseForm.resetFields();
        },handleClose:function(){

          _this.isOpenDrawer = false;

        },save(){

            if(_this.optBtnStatus == 'add'){
              _this.add();
            }else if(_this.optBtnStatus == 'update'){
               _this.update();
            }

        },async add(){

            // 先验证表单
            const isValid = await this.$refs.baseForm.validate();
            
            if (isValid) {

              var param = _this.account;
               param.birthday = _this.$com.formatDate(param.birthday);
              const response = await _this.$http.syncPost('/back_bin/account/add', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = false;
                  _this.$message({
                    message: '新增成功!',
                    type: 'success'
                  });

                  _this.getPage();

              }
              console.info('请求结果1:', response );

            }else{
              
                console.log('error submit!!');
                return false;
            }
         
        },deleteById:function(row){

                 _this.$confirm('确定删除吗?', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
                 }).then(() => {

                    var param = {'deleteId':row.loginAccount};

                   _this.$http.post('/back_bin/account/delete', param,function(msg){

                     _this.$message({
                       type: 'success',
                       message:'删除成功!'
                     });

                    _this.getPage();

                   });

                 });

        },async update(){

           try {

              var param = _this.account;
              const response = await _this.$http.syncPost('/back_bin/account/update', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = false;
                  _this.$message({
                    message: '修改成功!',
                    type: 'success'
                  });

                  _this.getPage();

              }
              console.info('请求结果1:', response )

            } catch (error) {
              console.error('请求失败:', error)
            }

        },async getId(row){

           try {
              _this.optBtnStatus = 'update';
              _this.resetForm();
              var param = {'keyId':row.loginAccount};

              const response = await _this.$http.syncGet('/back_bin/account/get_by_id', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = true;
                  if (_this.$refs.baseForm) {
                     // 重置表单数据和验证状态
                     _this.$refs.baseForm.resetFields();
                  }
                  
                   let account = response.data;
                   account['password1'] = '111111';
                   account.createTime = _this.$com.dateConvertTime(account.createTime);
                   account.lastUpdateTime = _this.$com.dateConvertTime(account.lastUpdateTime);
                  _this.account = account;

              }
              console.info('请求结果1:', response )

            } catch (error) {
              console.error('请求失败:', error)
            }

        },resetForm(){
        
           _this.dialogVisible = false;
            // 2. 关闭预览对话框
            _this.dialogVisible = false;
          _this.account = {"loginAccount":"","password":"","password1":"","accountName":"","phone":"","roleId":"","accountType":"","status":""}

        }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Account.vue